import type { Video } from "../../aysa_api/models/video.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";
import {
  encodeAspectRatio,
  decodeAspectRatio,
} from "../../aysa_api/models/aspect_ratio";

export const createBaseVideo = (): Video => {
  return {
    url: "",
    description: "",
    fallbackImage: createBaseImage(),
  };
};

export const decodeVideo = (reader: Reader, length: number): Video => {
  const end = reader.pos + length;
  const message = createBaseVideo();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.url = reader.string();

        break;
      case 2:
        message.description = reader.string();

        break;
      case 3:
        message.fallbackImage = decodeImage(reader, reader.uint32());

        break;
      case 4:
        message.aspectRatio = decodeAspectRatio(reader, reader.uint32());

        break;
      case 5:
        message.tag = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeVideo = (writer: Writer, message: Video): Writer => {
  writer.uint32(10).string(message.url);
  writer.uint32(18).string(message.description);
  encodeImage(writer.uint32(26).fork(), message.fallbackImage).ldelim();
  if (message.aspectRatio !== undefined) {
    encodeAspectRatio(writer.uint32(34).fork(), message.aspectRatio).ldelim();
  }
  if (message.tag !== undefined) {
    writer.uint32(42).string(message.tag);
  }

  return writer;
};
